var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("body", [
    _vm._m(0),
    _c("body", [
      this.largura > 500
        ? _c("div", { staticClass: "capa1" }, [
            _c(
              "div",
              { class: [this.largura > 500 ? "container" : "container"] },
              [
                _c("div", { class: [this.largura > 500 ? "row" : "row"] }, [
                  this.largura > 500
                    ? _c("div", { staticClass: "pt-4 col-lg-5" }, [
                        _c(
                          "h1",
                          {
                            staticClass:
                              "pl-0 text-white col-1 d-none d-lg-block mt-5 col-lg-12",
                          },
                          [
                            _vm._v(
                              " Negocie suas dívidas para você ficar no azul! "
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _c("div", { staticClass: "col-lg-2" }),
                  _c(
                    "div",
                    {
                      staticClass: "col-lg-5 justify-content-center d-flex",
                      staticStyle: { "margin-bottom": "100px" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "card",
                          staticStyle: {
                            "max-height": "max-content",
                            "margin-left": "100px",
                            "max-width": "450px",
                          },
                        },
                        [
                          _c("div", { staticClass: "border-top-0 px-3 pt-3" }, [
                            _c("h5", { staticClass: "text-body" }, [
                              _vm._v("Negociação de Dívidas"),
                            ]),
                            _c("h6", { staticClass: "text-muted mb-3" }, [
                              _vm._v(
                                " Descubra as melhores condições para você quitar suas dívidas com o Porto Bank. "
                              ),
                            ]),
                            _c("form", [
                              _c("div", { staticClass: "form-group mb-3" }, [
                                _c("div", { staticClass: "form-group" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "mask",
                                        rawName: "v-mask",
                                        value: [
                                          "###.###.###-##",
                                          "##.###.###/####-##",
                                        ],
                                        expression:
                                          "['###.###.###-##', '##.###.###/####-##']",
                                      },
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.form.accessdoc,
                                        expression: "form.accessdoc",
                                      },
                                    ],
                                    staticClass: "form-control form-control-sm",
                                    attrs: {
                                      type: "text",
                                      required: "",
                                      placeholder: "Seu CPF ou CNPJ",
                                      id: "accessDocInput",
                                      label: "Digite",
                                    },
                                    domProps: { value: _vm.form.accessdoc },
                                    on: {
                                      change: function ($event) {
                                        return _vm.changeAccessDocInput(
                                          _vm.form.accessdoc
                                        )
                                      },
                                      input: [
                                        function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.form,
                                            "accessdoc",
                                            $event.target.value
                                          )
                                        },
                                        _vm.saveDocument,
                                      ],
                                    },
                                  }),
                                ]),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "form-group mb-3 position-relative",
                                  },
                                  [
                                    (_vm.isPasswordVisible
                                      ? "text"
                                      : "password") === "checkbox"
                                      ? _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.form.promoCode,
                                              expression: "form.promoCode",
                                            },
                                          ],
                                          staticClass:
                                            "form-control form-control-sm",
                                          attrs: {
                                            placeholder: "Código de acesso",
                                            id: "passwordInput",
                                            disabled: _vm.loading,
                                            type: "checkbox",
                                          },
                                          domProps: {
                                            checked: Array.isArray(
                                              _vm.form.promoCode
                                            )
                                              ? _vm._i(
                                                  _vm.form.promoCode,
                                                  null
                                                ) > -1
                                              : _vm.form.promoCode,
                                          },
                                          on: {
                                            change: [
                                              function ($event) {
                                                var $$a = _vm.form.promoCode,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = null,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      _vm.$set(
                                                        _vm.form,
                                                        "promoCode",
                                                        $$a.concat([$$v])
                                                      )
                                                  } else {
                                                    $$i > -1 &&
                                                      _vm.$set(
                                                        _vm.form,
                                                        "promoCode",
                                                        $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          )
                                                      )
                                                  }
                                                } else {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "promoCode",
                                                    $$c
                                                  )
                                                }
                                              },
                                              function ($event) {
                                                return _vm.changeAccessCodeInput()
                                              },
                                            ],
                                          },
                                        })
                                      : (_vm.isPasswordVisible
                                          ? "text"
                                          : "password") === "radio"
                                      ? _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.form.promoCode,
                                              expression: "form.promoCode",
                                            },
                                          ],
                                          staticClass:
                                            "form-control form-control-sm",
                                          attrs: {
                                            placeholder: "Código de acesso",
                                            id: "passwordInput",
                                            disabled: _vm.loading,
                                            type: "radio",
                                          },
                                          domProps: {
                                            checked: _vm._q(
                                              _vm.form.promoCode,
                                              null
                                            ),
                                          },
                                          on: {
                                            change: [
                                              function ($event) {
                                                return _vm.$set(
                                                  _vm.form,
                                                  "promoCode",
                                                  null
                                                )
                                              },
                                              function ($event) {
                                                return _vm.changeAccessCodeInput()
                                              },
                                            ],
                                          },
                                        })
                                      : _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.form.promoCode,
                                              expression: "form.promoCode",
                                            },
                                          ],
                                          staticClass:
                                            "form-control form-control-sm",
                                          attrs: {
                                            placeholder: "Código de acesso",
                                            id: "passwordInput",
                                            disabled: _vm.loading,
                                            type: _vm.isPasswordVisible
                                              ? "text"
                                              : "password",
                                          },
                                          domProps: {
                                            value: _vm.form.promoCode,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.changeAccessCodeInput()
                                            },
                                            input: function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                _vm.form,
                                                "promoCode",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        }),
                                    _c("PasswordToggleButton", {
                                      attrs: {
                                        isPasswordVisible:
                                          _vm.isPasswordVisible,
                                      },
                                      on: {
                                        "toggle-visibility":
                                          _vm.togglePasswordVisibility,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c("div", { staticClass: "row" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-12 d-flex align-items-baseline justify-content-between",
                                    },
                                    [
                                      _c(
                                        "small",
                                        { staticClass: "form-text text-muted" },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass: "mt-4",
                                              attrs: { href: "#" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.getContacts(true)
                                                },
                                              },
                                            },
                                            [_vm._v(" Quero receber o código")]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "small",
                                        { staticClass: "form-text text-muted" },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass: "mt-4 text-right",
                                              attrs: { href: "#" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.getContacts(false)
                                                },
                                              },
                                            },
                                            [_vm._v("Esqueci o código")]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                              ]),
                              !_vm.loading
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "btn mb-2 btn-primary p-3",
                                      staticStyle: {
                                        width: "100%",
                                        "border-radius": "25px",
                                        "font-size": "16px",
                                      },
                                      attrs: {
                                        id: "btn-negociar",
                                        type: "button",
                                        disabled:
                                          !_vm.form.promoCode &&
                                          !_vm.form.accessdoc,
                                      },
                                      on: { click: _vm.login },
                                    },
                                    [_vm._v(" NEGOCIAR AGORA ")]
                                  )
                                : _vm._e(),
                            ]),
                            _c(
                              "div",
                              { staticClass: "mt-3" },
                              [
                                _c("ProgressLoading", {
                                  attrs: { loading: _vm.loading },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            ),
          ])
        : _vm._e(),
      this.largura < 500
        ? _c("div", { staticClass: "capa1" }, [
            _vm.largura < 500
              ? _c("div", { staticClass: "container p-0 pr-3 pl-3" }, [
                  _vm.largura < 500
                    ? _c("div", [
                        _c("div", { staticClass: "container" }, [
                          _c(
                            "div",
                            {
                              staticClass: "col-12",
                              style: _vm.largura < 500 ? "" : "",
                            },
                            [
                              _c("div", { staticClass: "card" }, [
                                _c(
                                  "div",
                                  { staticClass: "border-top-0 px-3 pt-3" },
                                  [
                                    _c("h5", { staticClass: "text-body" }, [
                                      _vm._v("Negociação de Dívidas"),
                                    ]),
                                    _c(
                                      "h6",
                                      { staticClass: "text-muted mb-3" },
                                      [
                                        _vm._v(
                                          " Descubra as melhores condições para você quitar suas dívidas com o Porto Bank. "
                                        ),
                                      ]
                                    ),
                                    _c("form", [
                                      _c(
                                        "div",
                                        { staticClass: "form-group mb-3" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "form-group" },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "mask",
                                                    rawName: "v-mask",
                                                    value: [
                                                      "###.###.###-##",
                                                      "##.###.###/####-##",
                                                    ],
                                                    expression:
                                                      "['###.###.###-##', '##.###.###/####-##']",
                                                  },
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.form.accessdoc,
                                                    expression:
                                                      "form.accessdoc",
                                                  },
                                                ],
                                                staticClass:
                                                  "form-control form-control-sm",
                                                attrs: {
                                                  type: "text",
                                                  required: "",
                                                  placeholder:
                                                    "Seu CPF ou CNPJ",
                                                  id: "accessDocInput",
                                                  label: "Digite",
                                                },
                                                domProps: {
                                                  value: _vm.form.accessdoc,
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.changeAccessDocInput(
                                                      _vm.form.accessdoc
                                                    )
                                                  },
                                                  input: [
                                                    function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        _vm.form,
                                                        "accessdoc",
                                                        $event.target.value
                                                      )
                                                    },
                                                    _vm.saveDocument,
                                                  ],
                                                },
                                              }),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "form-group mb-3 position-relative",
                                            },
                                            [
                                              (_vm.isPasswordVisible
                                                ? "text"
                                                : "password") === "checkbox"
                                                ? _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.form.promoCode,
                                                        expression:
                                                          "form.promoCode",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "form-control form-control-sm",
                                                    attrs: {
                                                      placeholder:
                                                        "Código de acesso",
                                                      id: "passwordInput",
                                                      disabled: _vm.loading,
                                                      type: "checkbox",
                                                    },
                                                    domProps: {
                                                      checked: Array.isArray(
                                                        _vm.form.promoCode
                                                      )
                                                        ? _vm._i(
                                                            _vm.form.promoCode,
                                                            null
                                                          ) > -1
                                                        : _vm.form.promoCode,
                                                    },
                                                    on: {
                                                      change: [
                                                        function ($event) {
                                                          var $$a =
                                                              _vm.form
                                                                .promoCode,
                                                            $$el =
                                                              $event.target,
                                                            $$c = $$el.checked
                                                              ? true
                                                              : false
                                                          if (
                                                            Array.isArray($$a)
                                                          ) {
                                                            var $$v = null,
                                                              $$i = _vm._i(
                                                                $$a,
                                                                $$v
                                                              )
                                                            if ($$el.checked) {
                                                              $$i < 0 &&
                                                                _vm.$set(
                                                                  _vm.form,
                                                                  "promoCode",
                                                                  $$a.concat([
                                                                    $$v,
                                                                  ])
                                                                )
                                                            } else {
                                                              $$i > -1 &&
                                                                _vm.$set(
                                                                  _vm.form,
                                                                  "promoCode",
                                                                  $$a
                                                                    .slice(
                                                                      0,
                                                                      $$i
                                                                    )
                                                                    .concat(
                                                                      $$a.slice(
                                                                        $$i + 1
                                                                      )
                                                                    )
                                                                )
                                                            }
                                                          } else {
                                                            _vm.$set(
                                                              _vm.form,
                                                              "promoCode",
                                                              $$c
                                                            )
                                                          }
                                                        },
                                                        function ($event) {
                                                          return _vm.changeAccessCodeInput()
                                                        },
                                                      ],
                                                    },
                                                  })
                                                : (_vm.isPasswordVisible
                                                    ? "text"
                                                    : "password") === "radio"
                                                ? _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.form.promoCode,
                                                        expression:
                                                          "form.promoCode",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "form-control form-control-sm",
                                                    attrs: {
                                                      placeholder:
                                                        "Código de acesso",
                                                      id: "passwordInput",
                                                      disabled: _vm.loading,
                                                      type: "radio",
                                                    },
                                                    domProps: {
                                                      checked: _vm._q(
                                                        _vm.form.promoCode,
                                                        null
                                                      ),
                                                    },
                                                    on: {
                                                      change: [
                                                        function ($event) {
                                                          return _vm.$set(
                                                            _vm.form,
                                                            "promoCode",
                                                            null
                                                          )
                                                        },
                                                        function ($event) {
                                                          return _vm.changeAccessCodeInput()
                                                        },
                                                      ],
                                                    },
                                                  })
                                                : _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.form.promoCode,
                                                        expression:
                                                          "form.promoCode",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "form-control form-control-sm",
                                                    attrs: {
                                                      placeholder:
                                                        "Código de acesso",
                                                      id: "passwordInput",
                                                      disabled: _vm.loading,
                                                      type: _vm.isPasswordVisible
                                                        ? "text"
                                                        : "password",
                                                    },
                                                    domProps: {
                                                      value: _vm.form.promoCode,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.changeAccessCodeInput()
                                                      },
                                                      input: function ($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.$set(
                                                          _vm.form,
                                                          "promoCode",
                                                          $event.target.value
                                                        )
                                                      },
                                                    },
                                                  }),
                                              _c("PasswordToggleButton", {
                                                attrs: {
                                                  isPasswordVisible:
                                                    _vm.isPasswordVisible,
                                                },
                                                on: {
                                                  "toggle-visibility":
                                                    _vm.togglePasswordVisibility,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c("div", { staticClass: "row" }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-12 d-flex align-items-baseline justify-content-between",
                                              },
                                              [
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass:
                                                      "form-text text-muted",
                                                  },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        staticClass: "mt-4",
                                                        staticStyle: {
                                                          color: "#0a0047",
                                                          cursor: "pointer",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.getContacts(
                                                              true
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " Quero receber o código"
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass:
                                                      "form-text text-muted",
                                                  },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "mt-4 text-right",
                                                        staticStyle: {
                                                          color: "#0a0047",
                                                          cursor: "pointer",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.getContacts(
                                                              false
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Esqueci o código"
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]),
                                        ]
                                      ),
                                      !_vm.loading
                                        ? _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn mb-2 btn-primary p-3",
                                              staticStyle: {
                                                width: "100%",
                                                "border-radius": "25px",
                                                "font-size": "16px",
                                              },
                                              attrs: {
                                                id: "btn-negociar",
                                                type: "button",
                                                disabled:
                                                  !_vm.form.promoCode &&
                                                  !_vm.form.accessdoc,
                                              },
                                              on: { click: _vm.login },
                                            },
                                            [_vm._v(" NEGOCIAR AGORA ")]
                                          )
                                        : _vm._e(),
                                    ]),
                                    _c(
                                      "div",
                                      { staticClass: "mt-3" },
                                      [
                                        _c("ProgressLoading", {
                                          attrs: { loading: _vm.loading },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "sec10 bg-light", style: _vm.largura > 500 ? "" : "" },
        [
          _c("div", { staticClass: "container" }, [
            _vm._m(1),
            _c(
              "div",
              {
                staticClass: "row d-flex justify-content-center text-dark",
                style: _vm.largura < 500 ? "padding: 40px;" : "",
              },
              [_vm._m(2), _vm._m(3), _vm._m(4), _vm._m(5)]
            ),
          ]),
        ]
      ),
      _vm._m(6),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("head", [
      _c("meta", { attrs: { charset: "utf-8" } }),
      _c("meta", {
        attrs: {
          name: "viewport",
          content: "width=device-width, initial-scale=1",
        },
      }),
      _c("link", { attrs: { rel: "icon", href: "img/favicon.ico" } }),
      _c("link", {
        attrs: { rel: "stylesheet", href: "theme.css", type: "text/css" },
      }),
      _c("title", [_vm._v("Porto - Portal de Autonegociação")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "row justify-content-center text-center mb-5" },
      [
        _c("div", { staticClass: "col-md-12 text-dark" }, [
          _c("h2", { staticClass: "py-4" }, [
            _vm._v(
              " Como fazer a negociação online do seu Cartão de Crédito Porto Bank "
            ),
          ]),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-6 col-lg-3 p-2 pl-3 pr-4" }, [
      _c("img", {
        staticClass: "img-fluid d-block mb-3",
        attrs: { src: "img/ic01.jpg" },
      }),
      _c("h5", [_vm._v("Identifique-se fazendo o login.")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-6 col-lg-3 p-2 pr-4 pl-3" }, [
      _c("img", {
        staticClass: "img-fluid d-block mb-3",
        attrs: { src: "img/ic02.jpg" },
      }),
      _c("h5", [_vm._v("Selecione a melhor opção para você.")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-6 col-lg-3 p-2 pr-4 pl-3" }, [
      _c("img", {
        staticClass: "img-fluid d-block mb-3",
        attrs: { src: "img/ic03.jpg" },
      }),
      _c("h5", {}, [_vm._v("Gere o boleto e faça o pagamento.")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-6 col-lg-3 p-2 pr-4 pl-3" }, [
      _c("img", {
        staticClass: "img-fluid d-block mb-3",
        attrs: { src: "img/ic04.jpg" },
      }),
      _c("h5", {}, [_vm._v("Pronto! Tudo certo com a sua negociação.")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("section", { staticClass: "bg-light py-3" }, [
      _c("div", { staticClass: "container py-5" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-11 mx-auto" }, [
            _c("h4", [
              _vm._v(" Tire suas dúvidas sobre a Negociação de Dívidas "),
              _c("hr", { staticStyle: { "border-color": "#fff" } }),
            ]),
            _c("div", { staticClass: "accordion", attrs: { id: "faq" } }, [
              _c("div", { staticClass: "card" }, [
                _c(
                  "div",
                  {
                    staticClass: "card-header p-2",
                    attrs: { id: "headingOne" },
                  },
                  [
                    _c("h5", { staticClass: "mb-0" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn-link",
                          staticStyle: { "font-size": "16px" },
                          attrs: {
                            type: "button",
                            "data-toggle": "collapse",
                            "data-target": "#collapse1",
                            "aria-expanded": "true",
                            "aria-controls": "collapse1",
                          },
                        },
                        [_vm._v(" O que é a Negociação de Dívidas? ")]
                      ),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "collapse",
                    attrs: { id: "collapse1", "aria-labelledby": "heading1" },
                  },
                  [
                    _c("div", { staticClass: "card-body px-4" }, [
                      _vm._v(
                        " É uma forma de encontrar o caminho mais fácil para negociar as suas dívidas em nossos produtos financeiros. "
                      ),
                    ]),
                  ]
                ),
              ]),
              _c("div", { staticClass: "card" }, [
                _c(
                  "div",
                  { staticClass: "card-header p-2", attrs: { id: "heading2" } },
                  [
                    _c("h5", { staticClass: "mb-0" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn-link collapsed",
                          staticStyle: { "font-size": "16px" },
                          attrs: {
                            type: "button",
                            "aria-expanded": "false",
                            "data-target": "#collapse2",
                            "aria-controls": "collapse2",
                            "data-toggle": "collapse",
                          },
                        },
                        [
                          _vm._v(
                            " De que forma posso pagar a negociação do cartão de crédito? "
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "collapse",
                    attrs: { id: "collapse2", "aria-labelledby": "heading2" },
                  },
                  [
                    _c("div", { staticClass: "card-body px-4" }, [
                      _vm._v(
                        " Você pode realizar o pagamento por meio de boleto bancário no portal ou pela central de atendimento. "
                      ),
                    ]),
                  ]
                ),
              ]),
              _c("div", { staticClass: "card" }, [
                _c(
                  "div",
                  { staticClass: "card-header p-2", attrs: { id: "heading3" } },
                  [
                    _c("h5", { staticClass: "mb-0" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn-link collapsed",
                          staticStyle: { "font-size": "16px" },
                          attrs: {
                            type: "button",
                            "data-toggle": "collapse",
                            "data-target": "#collapse3",
                            "aria-expanded": "false",
                            "aria-controls": "collapse3",
                          },
                        },
                        [
                          _vm._v(
                            " Quanto tempo leva, após o pagamento, para sair das restrições de crédito? "
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "collapse",
                    attrs: { id: "collapse3", "aria-labelledby": "heading3" },
                  },
                  [
                    _c("div", { staticClass: "card-body px-4" }, [
                      _vm._v(
                        " Após o pagamento da negociação, são até 5 dias úteis para que seu nome não esteja mais restrito. "
                      ),
                    ]),
                  ]
                ),
              ]),
              _c("div", { staticClass: "card" }, [
                _c(
                  "div",
                  { staticClass: "card-header p-2", attrs: { id: "heading4" } },
                  [
                    _c("h5", { staticClass: "mb-0" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn-link collapsed",
                          staticStyle: { "font-size": "16px" },
                          attrs: {
                            type: "button",
                            "data-toggle": "collapse",
                            "data-target": "#collapse4",
                            "aria-expanded": "false",
                            "aria-controls": "collapse4",
                          },
                        },
                        [
                          _vm._v(
                            " Como posso emitir uma segunda via de boleto de negociação? "
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "collapse",
                    attrs: { id: "collapse4", "aria-labelledby": "heading4" },
                  },
                  [
                    _c("div", { staticClass: "card-body px-4" }, [
                      _vm._v(
                        " Para cartão de crédito, acesse o portal e emita a segunda via de boleto. Para os demais produtos, entre em contato com a central de atendimento disponível e solicite a segunda via. "
                      ),
                    ]),
                  ]
                ),
              ]),
              _c("div", { staticClass: "card" }, [
                _c(
                  "div",
                  { staticClass: "card-header p-2", attrs: { id: "heading4" } },
                  [
                    _c("h5", { staticClass: "mb-0" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn-link collapsed",
                          staticStyle: { "font-size": "16px" },
                          attrs: {
                            type: "button",
                            "data-toggle": "collapse",
                            "data-target": "#collapse5",
                            "aria-expanded": "false",
                            "aria-controls": "collapse5",
                          },
                        },
                        [
                          _vm._v(
                            " Qual é o prazo para pagamento do boleto da negociação? "
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "collapse",
                    attrs: { id: "collapse5", "aria-labelledby": "heading5" },
                  },
                  [
                    _c("div", { staticClass: "card-body px-4" }, [
                      _vm._v(
                        " Você tem até 15 dias para pagar o boleto da negociação de dívida. "
                      ),
                    ]),
                  ]
                ),
              ]),
              _c("div", { staticClass: "card" }, [
                _c(
                  "div",
                  { staticClass: "card-header p-2", attrs: { id: "heading6" } },
                  [
                    _c("h5", { staticClass: "mb-0" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn-link collapsed",
                          staticStyle: { "font-size": "16px" },
                          attrs: {
                            type: "button",
                            "data-toggle": "collapse",
                            "data-target": "#collapse6",
                            "aria-expanded": "false",
                            "aria-controls": "collapse6",
                          },
                        },
                        [
                          _vm._v(
                            " Tenho condições especiais para negociar as minhas dívidas? "
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "collapse",
                    attrs: { id: "collapse6", "aria-labelledby": "heading6" },
                  },
                  [
                    _c("div", { staticClass: "card-body px-4" }, [
                      _vm._v(
                        " Para conferir as condições de negociação do cartão de crédito, acesse a nossa página. Para os demais produtos, entre em contato com as centrais de atendimento disponíveis e consulte se há uma oferta personalizada para você. "
                      ),
                    ]),
                  ]
                ),
              ]),
              _c("div", { staticClass: "card" }, [
                _c(
                  "div",
                  { staticClass: "card-header p-2", attrs: { id: "heading7" } },
                  [
                    _c("h5", { staticClass: "mb-0" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn-link collapsed",
                          staticStyle: { "font-size": "16px" },
                          attrs: {
                            type: "button",
                            "data-toggle": "collapse",
                            "data-target": "#collapse7",
                            "aria-expanded": "false",
                            "aria-controls": "collapse7",
                          },
                        },
                        [_vm._v(" O que é o Programa Desenrola Brasil? ")]
                      ),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "collapse",
                    attrs: { id: "collapse7", "aria-labelledby": "heading7" },
                  },
                  [
                    _c("div", { staticClass: "card-body px-4" }, [
                      _vm._v(
                        " O Desenrola Brasil é uma iniciativa do Governo Federal para ajudar na negociação de dívidas das pessoas com CPF negativado. As dívidas participantes serão aquelas negativadas pelos credores junto aos órgãos de crédito entre 01/01/2019 e 31/12/2022. Para consultar sua situação, entre em contato com o Serasa, Boa Vista e Quod. "
                      ),
                    ]),
                  ]
                ),
              ]),
              _c("div", { staticClass: "card" }, [
                _c(
                  "div",
                  { staticClass: "card-header p-2", attrs: { id: "heading8" } },
                  [
                    _c("h5", { staticClass: "mb-0" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn-link collapsed",
                          staticStyle: { "font-size": "16px" },
                          attrs: {
                            type: "button",
                            "data-toggle": "collapse",
                            "data-target": "#collapse8",
                            "aria-expanded": "false",
                            "aria-controls": "collapse8",
                          },
                        },
                        [_vm._v(" Quem está elegível ao Desenrola Brasil? ")]
                      ),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "collapse",
                    attrs: { id: "collapse8", "aria-labelledby": "heading8" },
                  },
                  [
                    _c("div", { staticClass: "card-body px-4" }, [
                      _vm._v(
                        " O Desenrola Brasil contempla duas faixas de público: "
                      ),
                      _c("br"),
                      _c("br"),
                      _vm._v(
                        " Faixa 1: pessoas físicas com renda mensal de até 2 salários-mínimos ou que estejam inscritas no Cadastro único para Programas Sociais do Governo Federal (Cadúnico) que possuam dívidas negativadas com bancos e/ou prestadoras de serviço de até R$ 5 mil. "
                      ),
                      _c("br"),
                      _c("br"),
                      _vm._v(
                        " Faixa 2: pessoas físicas com renda mensal de até R$ 20 mil que possuem dívidas com bancos e inscritas em cadastros de inadimplentes até 31/12/2022. "
                      ),
                      _c("br"),
                      _c("br"),
                      _vm._v(
                        " Para as duas fases, o prazo final de adesão é até 31/12/2023. "
                      ),
                    ]),
                  ]
                ),
              ]),
              _c("div", { staticClass: "card" }, [
                _c(
                  "div",
                  { staticClass: "card-header p-2", attrs: { id: "heading9" } },
                  [
                    _c("h5", { staticClass: "mb-0" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn-link collapsed",
                          staticStyle: { "font-size": "16px" },
                          attrs: {
                            type: "button",
                            "data-toggle": "collapse",
                            "data-target": "#collapse9",
                            "aria-expanded": "false",
                            "aria-controls": "collapse9",
                          },
                        },
                        [_vm._v(" Como negociar dívidas no Desenrola Brasil? ")]
                      ),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "collapse",
                    attrs: { id: "collapse9", "aria-labelledby": "heading9" },
                  },
                  [
                    _c("div", { staticClass: "card-body px-4" }, [
                      _vm._v(
                        " Clientes Faixa 1: a partir de setembro/23, em data a ser informada, poderão acessar o portal oficial do Desenrola Brasil, via site gov.br, que está em construção. "
                      ),
                      _c("br"),
                      _c("br"),
                      _vm._v(
                        " Clientes Faixa 2: desde 17/07/2023, podem negociar as dívidas diretamente nos canais de atendimento Porto Bank. "
                      ),
                    ]),
                  ]
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }